
export const sFechaPublicacion = '2026-10-13T00:24:49.8866945-06:00';
export const sVersion = 'vf1.1.610130024';
            